import { Component, OnInit } from '@angular/core';
import { TranslocoService } from "@ngneat/transloco";
import { FuncsService } from '../services/funcs.service';
import { TohumUiModule } from '@anadolu-commons/tohum-ui';

@Component({
  selector: 'app-kilavuzlar',
  standalone: true,
  imports: [TohumUiModule],
  templateUrl: './kilavuzlar.component.html',
})
export class KilavuzlarComponent implements OnInit {

  constructor(private translocoService: TranslocoService, private funcs: FuncsService) { }

  ngOnInit(): void {
  }
  sayfaYuklenemedi(error: any){
    this.funcs.hataMesajiVer(error);
  }
}
